import React, { useState, useEffect, Component } from 'react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-quartz.css';
import { AgGridReact } from 'ag-grid-react';
import { RiRefreshLine } from "react-icons/ri";
import Select from 'react-select';
import LeaseApiService from '../../services/apiService';
import { IoSearch } from "react-icons/io5";
import WindowedSelect from 'react-windowed-select';
import Pagination from '../pagination/pagination';
import Modal from 'react-bootstrap/Modal';
import { toast } from 'react-toastify';
import { useSelector } from 'react-redux';
import { getUserRole } from '../../../Redux/selecters';

const REACT_APP_REPORTS = process.env.REACT_APP_REPORTS_URL
const Listing = ({ formData, setFormData, listLeaseNos, listProperty, setTerminationList, terminationList }) => {
    const apiService = new LeaseApiService();
    const userRole = useSelector(getUserRole);
    // "FinanceAdmin" / "Finance Admin" (any stray spaces or casing)
    const isFinanceAdmin = String(userRole || '').replace(/s+/g, '').toLowerCase() === 'financeadmin';
    const [unitRent, setUnitRent] = useState(true);
    const [unitList, setUnitList] = useState([])
    const [deleteData, setDeleteData] = useState()
    const [pageSize, setPageSize] = useState(20)
    const [pagination, setPagination] = useState()
    const [contextMenu, setContextMenu] = useState(null)
    const [emailModal, setEmailModal] = useState(false);
    const [noticeData, setNoticeData] = useState(null); // row whose status is being changed to On Notice
    const onOpenModal = () => setEmailModal(true);
    const onCloseModal = () => setEmailModal(false);

    useEffect(() => {
        const handleClickOutside = () => setContextMenu(null);
        window.addEventListener('click', handleClickOutside);
        return () => window.removeEventListener('click', handleClickOutside);
    }, [])

    const handleClearFilters = () => {
        setFormData({
            Proprty: [{ label: 'Select Property', value: '' }],
            unitNo: [{ label: 'Select Unit No', value: '' }],
            leaseNo: [{ label: 'Select Lease No', value: '' }],
        });
    }
    const handlePropertyChange = async (selectedOption) => {
        if (selectedOption?.label === "All") {
            setUnitList([{ value: 'All', text: 'All' }]);
            setFormData({
                ...formData,
                Proprty: selectedOption,
                unitNo: [{ label: '', value: '' }],
                leaseNo: [{ label: 'Select Lease No', value: '' }],
            });
        } else {
            const params = new URLSearchParams();
            params.append('DropdownFor', 'TeminationListUnitNosByPropertyId');
            params.append('CascadValue', selectedOption?.value?.value);
            const res = await apiService.getApiParamater('TERMINATION_CASCAD', `?${params.toString()}`);
            setUnitList([{ value: 'All', text: 'All' }, ...res?.data?.items]);
            setFormData({
                ...formData,
                Proprty: selectedOption,
                unitNo: [{ label: 'Select Unit No', value: '' }],
                leaseNo: [{ label: 'Select Lease No', value: '' }],
            });
        }
    }
    const handleUitNo = async (selectedOption) => {
        let selectedLease = listLeaseNos?.find((comp) => comp.value === selectedOption?.value?.value)
        setFormData({
            ...formData,
            unitNo: selectedOption,
            leaseNo: { label: selectedLease?.value, value: selectedLease },
        });
    }
    const handleLeaseChange = (selectedOption) => {
        
        setFormData({
            ...formData,
            leaseNo: selectedOption,
            Proprty: [{ label: 'Select Property', value: '' }],
            unitNo: [{ label: 'Select Unit No', value: '' }],
        });
    }
    const handleSearch = async () => {
        try {
            const params = new URLSearchParams();
            params.append('PropertyNo', String(formData?.Proprty?.value?.value ?? '').trim() || "All");
            params.append('UnitNo', formData?.unitNo?.value?.text || "All");
            params.append('Leaseno', formData?.leaseNo?.label || "All");
            params.append('PageNo', 1);
            params.append('PageSize', 20);
            
            const res = await apiService.getApiParamater('TERMINATION_LIST', `?${params.toString()}`);
            setPagination(res.data.paginationData);
            setTerminationList(res?.data?.result || [])
        } catch (error) {
            console.error('Error fetching  data:', error);
        }
    }
    const getItems = async (newPageNo = pagination?.currentPage) => {
        try {
            const params = new URLSearchParams();
            params.append('PropertyNo', String(formData?.Proprty?.value?.value ?? '').trim() || "All");
            params.append('UnitNo', formData?.unitNo?.value?.text || "All");
            params.append('Leaseno', formData?.leaseNo?.label || "All");
            params.append('PageNo', newPageNo || 1);
            params.append('PageSize', 20);
            
            const res = await apiService.getApiParamater('TERMINATION_LIST', `?${params.toString()}`);
            setPagination(res.data.paginationData);
            setTerminationList(res?.data?.result || [])

        } catch (error) {
            console.error('Error fetching  data:', error);
        }
    }

    const columnDefs = [
        {
            headerName: '', field: 'recordId', cellRenderer: BtnCellRenderer, pinned: 'left',
            cellRendererParams: {
                clicked: function (field, exp2) {
                    handleMenuAction(field, exp2);
                },
            }, width: 30,
        },
        {
            headerName: 'Lease No', field: 'leaseNo', filter: true,
            floatingFilter: true, suppressMovable: true, width: 500
        },
        {
            headerName: 'Property Name', field: 'propertyName', filter: true,
            floatingFilter: true, suppressMovable: true, width: 500
        },
        {
            headerName: 'Unit No', field: 'unitNo', filter: true, floatingFilter: true, suppressMovable: true, width: 500
        }
    ]
    const handleMenuAction = (action, rowData) => {
        if (action === 'delete') {
            setDeleteData(rowData)
            onOpenModal(rowData);
        } else if (action === 'print') {
            handlePrint(rowData)
        } else if (action === 'notice') {
            setNoticeData(rowData)
        }
        setContextMenu(null); // Close the menu
    }
    const handlePrint = (rowData) => {
        if (rowData) {
            const token = localStorage.getItem("Token");
            const DB = localStorage.getItem("DataBase")
            if (!token) {
                alert("Auth token is missing! Unable to proceed.");
                return;
            }
            const popupWidth = 1000;
            const popupHeight = 600;
            const popupLeft = (window.screen.width - popupWidth) / 2;
            const popupTop = (window.screen.height - popupHeight) / 2;
            const popup = window.open(
                "",
                "ReportPopup",
                `width=${popupWidth},height=${popupHeight},left=${popupLeft},top=${popupTop},resizable=yes,scrollbars=yes`
            );

            if (popup) {
                const form = document.createElement("form");
                form.method = "POST";
                form.action = REACT_APP_REPORTS
                form.target = "ReportPopup";
                const inputs = [
                    { name: "authToken", value: token },
                    { name: "_db", value: DB },
                    { name: "LeaseNo", value: rowData?.leaseNo },
                    { name: "reportName", value: 'LTER' },
                ];

                inputs.forEach(({ name, value }) => {
                    const input = document.createElement("input");
                    input.type = "hidden";
                    input.name = name;
                    input.value = value;
                    form.appendChild(input);
                });

                document.body.appendChild(form);
                form.submit();
                document.body.removeChild(form);
            }
        }
    }
    const handleOnNotice = async () => {
        if (!noticeData) return
        try {
            const params = new URLSearchParams();
            params.append('Action', 'ChangeTerminationStatusByLeaseNo');
            params.append('LeaseNo', noticeData.leaseNo);
            const res = await apiService.getApiParamater('GET_UNITNO_DATA', `?${params.toString()}`);
            const raw = res?.data?.result?.data ?? res?.data?.result
            const data = Array.isArray(raw) ? raw[0] : raw
            const status = String(data?.Status ?? data?.status ?? '').toLowerCase()
            const message = data?.Message ?? data?.message ?? res?.data?.message
            if (status === 'success') {
                toast.success(message || 'Termination status updated successfully.')
                setNoticeData(null)
                getItems(pagination?.currentPage)
            } else {
                toast.error(message || 'Unable to change the status')
                setNoticeData(null)
            }
        } catch (error) {
            console.error('Error changing termination status:', error);
            toast.error('Unable to change the status')
        }
    }
    const handleDelete = async () => {
        if (deleteData) {
            try {
                
                let body = {
                    leaseNo: deleteData?.leaseNo
                }
                const res = await apiService.post('DELETE_TERMINATION_STATUS', body);
                if (res?.data?.statusCode === 201 || res?.data?.statusCode === 200) {
                    toast.success(res?.data?.message)
                    onCloseModal()
                    handleClearFilters()
                    setTerminationList([])
                }
            } catch (error) {
                console.error('Error Deleting  data:', error);
            }
        }
    }
    return (
        <div className=' mt-3'>
            <div className="cost-center-section mt-3">
                <div className="d-flex cursor-pointer slide-header"
                    onClick={() => setUnitRent(!unitRent)}>
                    <div className='param-label pt-1'>Search</div>
                </div>
                <div className={`slide-content ${unitRent ? 'open' : 'closed'}`}>
                    <div className={`border-box2 p-3 ${unitRent ? 'slide-in' : 'slide-out'}`}>
                        <div className="form-group" style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(340px, 1fr))', gap: '20px' }}>
                            <div className='d-flex'>
                                <Select
                                    className="w-100 p-0"
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9
                                    })}

                                    menuPortalTarget={document.body}
                                    
                                    menuPlacement="auto"
                                    menuShouldScrollIntoView={false}
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                            color: state.isFocused ? '#000 ' : '#000',
                                            ':hover': {
                                                backgroundColor: '#F5F5F5',
                                                color: '#000 ',
                                            },
                                        }),
                                    }}
                                    value={formData.Proprty}
                                    onChange={(selectedOption) => handlePropertyChange(selectedOption)}
                                    options={listProperty?.slice()?.sort((a, b) => a.text.localeCompare(b.text, undefined, { numeric: true, sensitivity: 'base' }))?.map((rec) => ({ value: rec, label: rec?.text }))}
                                />
                            </div>
                            <div className='d-flex'>
                                <Select
                                    className="w-100 p-0"
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9
                                    })}

                                    menuPortalTarget={document.body}
                                    isClearable
                                    menuPlacement="auto"
                                    menuShouldScrollIntoView={false}
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                                            color: state.isFocused ? '#000 ' : '#000',
                                            ':hover': {
                                                backgroundColor: '#F5F5F5',
                                                color: '#000 ',
                                            },
                                        }),
                                    }}
                                    value={formData.unitNo}
                                    onChange={(selectedOption) => handleUitNo(selectedOption)}
                                    options={unitList?.slice()?.sort((a, b) => a.text.localeCompare(b.text, undefined, { numeric: true, sensitivity: 'base' }))?.map((rec) => ({ value: rec, label: rec?.text }))}
                                />
                            </div>
                            <div className='d-flex'>
                                <WindowedSelect
                                    className="w-100  p-0"
                                    theme={(theme) => ({
                                        ...theme,
                                        borderRadius: 5,
                                        padding: 9
                                    })}

                                    menuPortalTarget={document.body}
                                    isClearable
                                    menuPlacement="auto"
                                    menuShouldScrollIntoView={false}
                                    styles={{
                                        menuPortal: base => ({ ...base, zIndex: 9999 }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? '#F5F5F5' : null,
                                            color: '#000',
                                            ':hover': {
                                                backgroundColor: '#F5F5F5',

                                                color: '#000',
                                            },
                                        }),
                                    }}
                                    options={
                                        listLeaseNos
                                            ?.slice(0, 5000)
                                            .map(rec => ({ value: rec, label: rec?.value }))
                                    }
                                    value={formData.leaseNo}
                                    onChange={(selectedOption) => handleLeaseChange(selectedOption)}
                                />
                            </div>
                            <div className="d-flex gap-2">
                                <div className='mainbtnGry flex-end gap-2 w-50' onClick={handleSearch}>
                                    <IoSearch color='#fff' className='center mt-1 mx-2' />
                                    <div className='center'>Search</div>
                                </div>
                                <div className='mainbtnRed flex-end gap-2 w-50' onClick={handleClearFilters}>
                                    <RiRefreshLine color='#fff' className='center mt-1 mx-2' />
                                    <div className='center'>Reset</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className='gridshad  mt-2'>
                <div className="ag-theme-quartz" style={{ height: 470 }}>
                    <AgGridReact
                        getRowStyle={(params) => {
                            if (params.node.rowIndex % 2 === 0) {
                                return { background: '#F0EDF5' };
                            } else {
                                return { background: '#fff' };
                            }
                        }}
                        rowData={terminationList}
                        enableFilter={true}
                        floatingFilter={true}
                        columnDefs={columnDefs}
                        frameworkComponents={{ BtnCellRenderer }}
                        context={{ setContextMenu }}
                    />
                </div>
                <Pagination pageSize={pageSize} setPageSize={setPageSize} pagination={pagination} getItems={getItems} />
            </div>

            {contextMenu && (
                <div
                    style={{
                        position: 'absolute',
                        top: contextMenu.mouseY,
                        left: contextMenu.mouseX,
                        backgroundColor: 'white',
                        border: '1px solid gray',
                        zIndex: 1000,
                        padding: '10px 30px',
                        borderRadius: '8px',
                        boxShadow: '0px 2px 6px rgba(0,0,0,0.2)'
                    }}
                >
                    <div style={{ display: 'grid' }}>
                        <button className="btn btn-secondary mt-2" onClick={() => handleMenuAction('print', contextMenu.data)}>
                            Print
                        </button>
                        {isFinanceAdmin && (
                            <button className="btn btn-secondary mt-2" onClick={() => handleMenuAction('notice', contextMenu.data)}>
                                On Notice
                            </button>
                        )}
                        {/* <button className="btn btn-secondary mt-2" onClick={() => handleMenuAction('delete', contextMenu.data)}>
                            Delete
                        </button> */}
                    </div>
                </div>
            )}

            <Modal size="md"
                show={!!noticeData} onHide={() => setNoticeData(null)}
                backdrop="static"
                contentLabel='On Notice Modal'
            >
                <Modal.Header closeButton>
                    <Modal.Title className='center'>Confirmation</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    Do you want to change the status{noticeData?.leaseNo ? ` of lease ${noticeData.leaseNo}` : ''}?
                </Modal.Body>
                <Modal.Footer className='end p-3'>
                    <button className='mainbtnGry' onClick={() => setNoticeData(null)}>Cancel</button>
                    <button className='mainbtnRed' onClick={handleOnNotice}>OK</button>
                </Modal.Footer>
            </Modal>

            <Modal size="md"
                show={emailModal} onHide={() => setEmailModal(false)}
                backdrop="static"
                contentLabel='Email Modal'
            >
                <Modal.Header closeButton>
                    <Modal.Title className='center'>Are you sure you want to delete</Modal.Title>
                </Modal.Header>
                <Modal.Body>

                </Modal.Body>
                <Modal.Footer className='end p-3'>
                    <button className='mainbtnGry' onClick={onCloseModal}>Close</button>
                    <button className='mainbtnRed' onClick={handleDelete}>Delete</button>
                </Modal.Footer>
            </Modal>
        </div>
    );
};

class BtnCellRenderer extends Component {
    constructor(props) {
        super(props);
        this.handleClick = this.handleClick.bind(this);
    }

    handleClick(e) {
        e.stopPropagation(); // Prevent row selection
        const { context, data } = this.props;

        if (context && context.setContextMenu) {
            context.setContextMenu({
                mouseX: e.clientX,
                mouseY: e.clientY,
                data: data
            });
        }
    }

    render() {
        return (
            <div className='center pt-1'>
                <span onClick={this.handleClick} style={{ cursor: 'pointer', fontSize: '30px' }}>
                    &#8942; {/* Vertical Ellipsis */}
                </span>
            </div>
        );
    }
}
export default Listing;